import classNames from 'classnames';
import { COMMENT_STATUS_ENUM } from 'modules/community/constants';

class CommunityHistoryService {
  classCommentDetailInline = (isTopic) =>
    classNames({
      'comment-list__history__comment-detail__content--inline': !isTopic
    });

  classCommentDetailContent = (isTopic) =>
    classNames('comment-list__history__comment-detail__content', {
      'comment-list__history__comment-detail__content--opened': !isTopic
    });

  classTopicCommentsOpened = (showUserPhoto) =>
    classNames({
      'comment-list__history__comment-detail__content__topic-comments--opened':
        showUserPhoto
    });

  classCommentDetail = (isTopic) =>
    classNames('comment-list__history__comment-detail', {
      'comment-list__history__comment-detail--no-border': !isTopic
    });

  classCommentDetailContentAnswer = (showUserPhoto) =>
    classNames({
      'comment-list__history__comment-detail__answer': showUserPhoto
    });

  statusMessage = {
    [COMMENT_STATUS_ENUM.APPROVED]:
      'community.approve_notification_message_success',
    [COMMENT_STATUS_ENUM.DISAPPROVED]:
      'community.disapprove_notification_message_success',
    [COMMENT_STATUS_ENUM.SPAM_CONFIRMED]:
      'community.spam_notification_message_success'
  };
}

export default new CommunityHistoryService();
